/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { postSignInThunk, postSignOutThunk } from './auth.thunk';
import { ThunkStatus } from '../../enums/ThunkStatus';

/* Initial State */
const initialState = {
  status: ThunkStatus.IDLE,
  /*
    userData will contain the following properties:
      - roles: [], // organization roles
      - extraRoles: [], // outside organization roles, based on submissionId and tenantId
   */
  userData: undefined,
  error: undefined,
};

/* Slice */
export const authSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(postSignInThunk.pending, (state) => {
        state.status = ThunkStatus.LOADING;
      })
      .addCase(postSignInThunk.fulfilled, (state, action) => {
        state.status = ThunkStatus.SUCCEEDED;
        state.userData = action.payload;
        state.error = undefined;
      })
      .addCase(postSignInThunk.rejected, (state, action) => {
        state.status = ThunkStatus.FAILED;
        state.userData = initialState.userData;
        state.error = action.error.message;
      })
      .addCase(postSignOutThunk.fulfilled, (state) => {
        state.status = initialState.status;
        state.userData = initialState.userData;
        state.error = initialState.error;
      });
  },
});

/* Selectors */
const selectAuth = state => state[authSlice.name];
export const selectAuthStatus = createSelector(selectAuth, ({ status }) => status);
export const selectAuthUserData = createSelector(selectAuth, ({ userData }) => userData);
export const selectAuthUserDataExtraRoles = createSelector(selectAuthUserData, ({ extraRoles }) => extraRoles);
